import React from 'react';
import { Helmet } from 'react-helmet';
import MultiStepForm from '../Components/MultiStepForm/MultiStepForm';

const MultiFormService = () => (
  <>
    <Helmet>
      <title>Services | MilaajBrandset</title>
      <meta
        name="description"
        content="Explore our comprehensive services, including branding, web design, digital marketing, and more, tailored to help your business grow."
      />
      <meta
        name="keywords"
        content="MilaajBrandset services, branding, web design, digital marketing, e-commerce solutions"
      />
      <meta property="og:title" content="Services | MilaajBrandset" />
      <meta
        property="og:description"
        content="Explore our services like branding, web design, digital marketing, and e-commerce solutions tailored for your business growth."
      />
    </Helmet>
    <MultiStepForm />
  </>
);

export default MultiFormService;